// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__ASomj","submit":"Form_submit__VBGW8","buttonWrapper":"Form_buttonWrapper__bC5Cx"};